import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import style from './style.module.less';

/**
 * @param {object} props
 * @param {node} props.children
 * @param {string} props.pageTitle
 * @param {node} props.filterBar
 * @returns {JSX.Element}
 */

export const AnalyticsPage = ({ children, pageTitle, filterBar }) => (
  <div className={style['analytics-page-content']}>
    <Text className={style['analytics-page-header']} textType={TextType.H1} value={pageTitle.headerMessage} />
    {filterBar}
    {children}
  </div>
);
